import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { extensionsRoute } from 'src/app/app-routing.module';
import { ConfirmationDialogService } from 'src/app/common-components/confirmation-dialog/confirmation-dialog.service';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { ExtensionDetailSaveEvent } from '../../extension-details/models/extension-detail-form-submit-event';
import { extensionRegisterAdapterActions } from '../../extension-register/state/extension-register.actions';
import { AddExtensionApiService } from '../services/add-extension-api.service';
import * as AddExtensionActions from './add-extension.actions';

@Injectable()
export class AddExtensionEffects {
   createExtension$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddExtensionActions.createExtension),
         withLatestFrom(this.store.select(getSelectedAccountId)),
         switchMap(([action, accountId]) => {
            const extension: ExtensionDetailSaveEvent = {
               ...action.extensionSave,
               extension: {
                  extension: {
                     ...action.extensionSave.extension.extension,
                     accountId: accountId ?? 0,
                  },
               },
            };
            return this.addExtensionApiService.create(extension).pipe(
               map((executionResult) => {
                  return AddExtensionActions.createExtensionSuccess({
                     extensionId: executionResult.data.extension.extensionId,
                     extensionNumber: executionResult.data.extension.number,
                     continuous: action.continuous,
                  });
               }),
               catchError((error) => {
                  return of(AddExtensionActions.createExtensionFailure(error));
               })
            );
         })
      );
   });

   createExtensionSuccess$ = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(AddExtensionActions.createExtensionSuccess),
            tap((result) => {
               this.snackbar.open(`Extension ${result.extensionNumber} Created`);
               if (!result.continuous) {
                  this.dialogService.closeFormComponent();
                  this.router.navigate([`/${extensionsRoute}/${result.extensionId}`]);
               } else {
                  this.store.dispatch(extensionRegisterAdapterActions.pageEnter());
               }
            })
         );
      },
      {
         dispatch: false,
      }
   );

   constructor(
      private actions$: Actions,
      private addExtensionApiService: AddExtensionApiService,
      private store: Store,
      private snackbar: MatSnackBar,
      private dialogService: LcsDialogService,
      private confirmationService: ConfirmationDialogService,
      private router: Router
   ) {}
}
